import contentModalController from './content.modal.controller';
import courseDetailModalController from './coursedetail.modal.controller';
import modalInstanceController from './modalinstance.controller';
import crmFormController from './crmform.controller';
import formValidationController from './formvalidation.controller';

const moduleName = 'usc.core.controllers';

angular.module(moduleName, [])
    .controller('courseModalController', ['$uibModalInstance', '$sce', 'course', courseDetailModalController])
    .controller('modalInstanceCtrl', ['$scope', '$uibModalInstance', 'item', modalInstanceController])
    .controller('CrmFormCtrl', ['$scope', '$http', crmFormController])
    .controller('FormValidationCtrl', ['$scope', '$http', formValidationController])
    .controller('contentModalController', ['$uibModalInstance', '$sce', 'item', 'content', 'hideHeader', contentModalController])

export default moduleName;